import * as XLSX from "xlsx";

const safeText = (value) => String(value || "").trim() || "-";

export const formatExportDate = (value) => {
  const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : safeText(value);
};

export const buildTimesheetExportRows = (
  exportData = {},
  { includeDateInHeader = false } = {}
) => {
  const dates = Array.isArray(exportData.dates) ? exportData.dates : [];
  const rows = Array.isArray(exportData.rows) ? exportData.rows : [];
  const from = exportData.range?.from || "";
  const to = exportData.range?.to || "";

  const title =
    from && to
      ? `วันที่ ${formatExportDate(from)} - ${formatExportDate(to)}`
      : "Timesheet";
  const headers = [
    "ชื่อ นามสกุลพนักงาน",
    "แผนก",
    "ลูกค้า",
    "Project",
    ...dates.map(({ day, date }) =>
      includeDateInHeader
        ? `${day ? `${day} ` : ""}${formatExportDate(date)}`
        : day || formatExportDate(date)
    ),
    "Total",
  ];
  const dataRows = rows.map((row) => [
    safeText(row.employeeName),
    safeText(row.department),
    safeText(row.clientName),
    safeText(row.projectName),
    ...dates.map(({ date }) => Number(row.dailyHours?.[date] || 0)),
    Number(row.totalHours || 0),
  ]);

  return { title, headers, dataRows };
};

export const exportTimesheetWorkbook = (exportData = {}, options = {}) => {
  const { title, headers, dataRows } = buildTimesheetExportRows(
    exportData,
    options
  );
  const worksheet = XLSX.utils.aoa_to_sheet([[title], headers, ...dataRows]);
  const lastColumnIndex = Math.max(headers.length - 1, 0);

  worksheet["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: lastColumnIndex } },
  ];
  worksheet["!cols"] = headers.map((_, index) => ({
    wch: index === 0 ? 26 : index === 1 ? 18 : index < 4 ? 24 : 12,
  }));
  worksheet["!autofilter"] = {
    ref: XLSX.utils.encode_range({
      s: { r: 1, c: 0 },
      e: { r: Math.max(dataRows.length + 1, 1), c: lastColumnIndex },
    }),
  };

  for (let row = 2; row < dataRows.length + 2; row += 1) {
    for (let column = 4; column <= lastColumnIndex; column += 1) {
      const cell = worksheet[XLSX.utils.encode_cell({ r: row, c: column })];
      if (cell) cell.z = "General";
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Timesheet");

  const from = exportData.range?.from || "from";
  const to = exportData.range?.to || "to";
  XLSX.writeFile(workbook, `Timesheet_${from}_to_${to}.xlsx`);
};
